import { render, staticRenderFns } from "./ContatoInput.vue?vue&type=template&id=2cf5ecec&scoped=true&"
import script from "./ContatoInput.vue?vue&type=script&lang=js&"
export * from "./ContatoInput.vue?vue&type=script&lang=js&"
import style0 from "./ContatoInput.vue?vue&type=style&index=0&id=2cf5ecec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf5ecec",
  null
  
)

export default component.exports